import PropTypes from 'prop-types';
import React from 'react';

/**
 * React function representing a Video component
 * @prop {boolean} autoPlay
 * @prop {boolean} controls
 * @prop {boolean} loop
 * @prop {boolean} muted
 * @prop {boolean} playsInline
 * @prop {string} src
 */
export const Video = (props) => {
    const videoRef = props.videoRef;

    return (
        <div className='relative'>
            <video
                autoPlay={props.autoPlay}
                className='w-full'
                controls={props.controls}
                loop={props.loop}
                muted={props.muted}
                playsInline={props.playsInline}
                ref={videoRef}
                src={props.src} />
        </div>
    );
};

Video.propTypes = {
    autoPlay: PropTypes.bool,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    muted: PropTypes.bool,
    playsInline: PropTypes.bool,
    videoRef: PropTypes.object,
    src: PropTypes.string.isRequired
};

export default Video;
